import React from 'react';

const SectionHero = () => {
  return (
    <section className="section section-dark section-hero section-careers-hero">
      <div className="container">
        <div className="section-content-wrapper">
          <h3 className="section-title">Careers</h3>
          <h1 className="hero-title">
            BRAVE THINKERS <br />
            WANTED
          </h1>
        </div>
      </div>
    </section>
  );
};

export default SectionHero;
